// i18n area 'common' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.no-NO.meta.json.
import type { enUS } from './common'

export const noNO: typeof enUS = {
  nav: {
    home: 'Hjem',
    vms: 'Virtuelle maskiner',
    templates: 'Templater',
    importVms: 'Importer VM-er',
    containers: 'Containere',
    containersApps: 'Apper',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-bilder',
    containersOciRegistries: 'OCI-registryer',
    containersCtTemplates: 'CT-templater',
    networkServices: 'Nettverkstjenester',
    firewall: 'Brannmur',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Overvåking',
    cluster: 'Kluster',
    clusterSettings: 'Globale innstillinger',
    clusterNodes: 'Noder',
    clusterDevices: 'USB- og PCIe-ressurser',
    clusterFederation: 'Føderasjon',
    network: 'Nettverk',
    overlayNetworks: 'Overlay-nettverk',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Data',
    storages: 'Storage',
    hci: 'Hyperkonvergens',
    ceph: 'Ceph',
    system: 'System',
    tasks: 'Tasks',
    events: 'Hendelser',
    audit: 'Audit',
    diagnostics: 'Diagnostikk',
    notifications: 'Varsler',
    proximity: 'TVirt Proximity',
    users: 'Brukere og grupper',
    groups: 'Grupper',
    mfa: 'MFA',
    realms: 'Realm og SSO',
    rbac: 'Roller og tillatelser',
    credentials: 'Legitimasjoner',
    scopes: 'Scoper',
    tags: 'Tagger',
    explorer: 'Utforsk',
    licensing: 'Lisens',
    information: 'Informasjon'
  },
  mode: {
    light: 'Lys',
    dark: 'Mørk',
    system: 'System',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Språk'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Nord-Amerika',
    southAmerica: 'Sør-Amerika',
    asia: 'Asia'
  },
  notFound: {
    title: 'Fant ikke siden',
    body: 'Denne adressen svarer ikke til noen TVirt-side — den kan ha flyttet med en oppdatering, eller lenken er gammel.',
    backHome: 'Tilbake til Hjem'
  },
  scopeBrowser: {
    title: 'Scoper',
    all: 'Hele klusteret',
    noChildren: 'Ingen under-scoper her',
    recursive: 'Ta med etterkommere',
    collapse: 'Skjul scope-panelet',
    openPicker: 'Utforsk scopene',
    up: 'Ett nivå opp',
    countTooltip: '{direct} i denne scopen · {total} med etterkommere'
  },
  search: {
    tooltip: 'Søk (⌘K)',
    placeholder: 'Søk VM-er, nett, storage…',
    empty: 'Ingen resultater',
    groups: {
      recent: 'Nylige',
      shortcuts: 'Snarveier',
      actions: 'Handlinger',
      goTo: 'Gå til'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Node'
    },
    footer: {
      navigate: 'naviger',
      open: 'åpne',
      close: 'lukk'
    },
    actions: {
      createVm: 'Opprett VM…',
      uploadIso: 'Last opp ISO…',
      clusterSettings: 'Kluster-innstillinger',
      consoleOf: 'Gå til konsollen til {name}'
    }
  },
  stub: {
    containersSummary: 'Applikasjoner og systemcontainere (CT), med OCI-bildene, registryene og templatene deres — forvaltet ved siden av VM-ene dine.',
    sectionSummary_vms: 'Virtuelle maskiner og templatene deres — livssyklus, snapshots, migrering og konsoll.',
    sectionSummary_storages: 'Storagene der VM-enes disker, bilder og metadata lever.',
    sectionSummary_catalogs: 'Hjemmet til klusterets fil-artefakter: ISO-bilder, CT- og VM-templater og OCI-arkiver, organisert i kataloger.',
    sectionSummary_overlay: 'VXLAN-overlay-nettverk mellom klusterets noder.',
    sectionSummary_fabric: 'Inventaret over det fysiske nettet — switcher, porter, LAGG-er og logiske nett.',
    sectionSummary_ipam: 'Adresseringen avledet av fabric- og overlay-nettene: hvem som holder hver adresse.',
    sectionSummary_services: 'DHCP- og DNS-servere avledet av nettverksregisteret.',
    sectionSummary_ceph: 'Forvaltede Ceph-kluster på TVirt-nodene.',
    sectionSummary_hci: 'De hyperkonvergente storage-teknologiene på TVirt-nodene.',
    sectionSummary_cluster: 'Noder, medlemskap og klusterinnstillinger.',
    containers: 'Systemcontainerne er i roadmapen — denne seksjonen vil huse dem.',
    containersApps: 'De containeriserte applikasjonene er i roadmapen — dette området vil huse dem.',
    containersPods: 'Pods samler containere som deler nettverk og volumer — instansene er appene.',
    containersCt: 'Systemcontainerne (CT) er i roadmapen — dette området vil huse dem.',
    multiscsi: 'TVStor MultiSCSI er i roadmapen — dette området vil huse den.',
    clusterFederation: 'Føderasjon mellom TVirt-kluster er i roadmapen — dette området vil huse den.',
    containersOciImages: 'OCI-bildene er i roadmapen — dette området vil huse dem.',
    containersOciRegistries: 'OCI-registryene er i roadmapen — dette området vil huse dem.',
    containersCtTemplates: 'CT-templatene er i roadmapen — dette området vil huse dem.',
    importVms: 'ESXi- og Proxmox-importerne kommer hit: konvertering av guester og massemigrering inn i TVirt.',
    backup: 'Den integrerte backupen kommer med 6.2: dedupliserte content-addressed repositoryer, CBT-inkrementeller, immutabilitetsvinduer og repo-to-repo-replikering.',
    monitoring: 'Dashboardene for kluster-wide ressurskamp (cpu.ready, PSI-press, integrerte alerts) er på vei — i dag lever de samme metrikkene i detaljene til hver VM.'
  },
  home: {
    welcome: 'Du er logget inn som: {name}',
    subtitle: 'Her er TVirt-klusteret ditt i ett blikk.',
    loadError: 'Kunne ikke laste oversikten — er TVirt-backenden tilgjengelig?',
    health: {
      ok: 'Alt i orden',
      warning: 'Obs',
      critical: 'Kritiske problemer'
    },
    reason: {
      'node-down': '{subject} er avslått',
      'node-stale': '{subject} har ikke latt høre fra seg på en stund',
      'node-maintenance': '{subject} i vedlikehold',
      'tasks-failed': {
        one: '{n} feilet task de siste 24t',
        other: '{n} feilede tasks de siste 24t'
      },
      'storage-degraded': 'storage {subject} degradert',
      'storage-error': 'storage {subject} i feil',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klusterets store er utilgjengelig',
      'license-absent': 'ingen lisens — nye VM-er kan ikke starte',
      'license-expired': 'lisens utløpt — nye VM-er kan ikke starte',
      'license-exceeded': 'lisensgrense overskredet — nye VM-er kan ikke starte',
      'failover-reserve-eroded': 'failover-reserven er nesten oppbrukt',
      'failover-reserve-exhausted': 'failover-reserven er oppbrukt — nye VM-er kan ikke starte',

      'oci-cache-nearly-full': 'OCI-cachen på {subject} er nesten full — digester fjernes for hånd',
      'oci-cache-full': 'OCI-cachen på {subject} er full — ingen pull lykkes før digester fjernes',
      'config-replica-empty': 'konfigurasjonsreplikaen på {subject} er TOM — noden har ingen klyngekonfigurasjon før en replikering lykkes',
      'config-replica-stalled': 'konfigurasjonsreplikering på {subject} står stille — den lokale kopien henger etter klyngens konfigurasjon'
    },
    staleChip: 'Ikke oppdaterte data',
    staleAsOf: 'siste replika {time}',
    zone: {
      nodes: 'Noder',
      failoverReserve: 'Failover-reserve',
      capacity: 'Kapasitet',
      workload: 'Arbeidslast',
      protection: 'Beskyttelse',
      activity: 'Nylig aktivitet'
    },
    reserve: {
      state: {
        ok: 'Reserve intakt',
        eroded: 'Reserve nesten oppbrukt',
        exhausted: 'Reserve oppbrukt',
        unknown: 'Reserve ukjent'
      },
      tolerate: {
        one: 'tolererer tap av {n} node',
        other: 'tolererer tap av {n} noder'
      },
      usedOf: '{used} / {allowed} GiB i bruk',
      keepFree: '{n} GiB holdt ledige for failover',
      expendable: 'herav {n} som kan ofres i drift',
      headroom: '{n} GiB kan fortsatt startes',
      short: 'reserven mangler {n} GiB — nye VM-er kan ikke starte',
      hp: {
        usedOf: 'Sider på {size} — i bruk: {used} / {allowed}',
        keepFree: 'holdt ledige for failover: {keep}',
        headroom: 'kan fortsatt startes: {n}',
        short: 'mangler i reserven: {n} — nye VM-er med enorme sider kan ikke starte'
      },
      worstCase: 'verste fall: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ingen node har deklarert minnet sitt ennå — reserven er ikke beregnbar og ingen start avvises.',
      reason: {
        attestedDown: 'attestert avslått',
        maintenance: 'i vedlikehold',
        unreachable: 'utilgjengelig',
        capacityUnknown: 'minne ikke deklarert'
      }
    },
    node: {
      cpu: '{n} CPU-er',
      cpuTopology: '{cores} kjerner / {threads} tråder',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktiv VM',
        other: '{n} aktive VM-er'
      },
      activeVmsUnknown: 'aktive VM-er ukjent',
      lastSeen: 'sett {time}',
      neverSeen: 'aldri sett',
      down: 'Avslått',
      maintenance: 'Vedlikehold',
      stale: 'Utilgjengelig'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisjonert',
      reserve: 'reserve {n} GiB',
      unobserved: 'kapasitet ikke observert ennå',
      empty: 'Ingen storage ennå'
    },
    workload: {
      vms: 'Virtuelle maskiner',
      apps: 'Apper',
      services: 'Nettverkstjenester',
      empty: 'Ingen ennå',
      phasesUnknown: 'fordeling per fase ikke tilgjengelig'
    },
    protection: {
      none: 'Ingen backup-mål konfigurert — beskytt konfigurasjonen din.',
      configure: 'Konfigurer checkpoints',
      noRuns: 'Ingen checkpoint er opprettet ennå.',
      last: 'Siste checkpoint',
      onTarget: 'på {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Ingen nylig aktivitet',
      failed24: {
        one: '{n} feilet på 24t',
        other: '{n} feilet på 24t'
      },
      viewAll: 'Se alle tasks'
    }
  },
  notes: {
    title: 'Notater',
    tabEdit: 'Rediger',
    tabPreview: 'Forhåndsvisning',
    placeholder: 'Operatørens frie notater — Markdown rendres i forhåndsvisningen',
    empty: 'Ingen notater',
    tooLarge: 'Notatene overskrider grensen på 64 KiB',
    saveError: 'Lagringen av notatene mislyktes'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Svaret fra backend inneholder en verdi dette grensesnittet ikke kjenner: {field}={value} — oppdater webgrensesnittet til backend-versjonen.',
    contractErrorItems: '{count} objekter i denne listen kan ikke leses av dette grensesnittet ({field}={value}), og de vises ikke.',
    staleHint: 'Storen er ikke tilgjengelig — dette er denne nodens config-replika; flåtens tilstand er ukjent.',
    staleStateAge: 'tilstand per {time}',
    staleStateNever: 'tilstanden er aldri mottatt fra storen: du ser bare denne nodens egne observasjoner',
    staleStateTooltip: 'Klyngens store er ikke tilgjengelig: den observerte tilstanden (fase, node, agent) kommer fra denne nodens tilstandsreplika og stammer fra siste vellykkede lesing fra storen — den kan være utdatert.',
    noPermission: 'Du har ikke tillatelse til denne handlingen',
    actionStillRunning: 'Handlingen pågår fortsatt — utfallet er ennå ikke kjent',
    staleWrite: 'Noen andre endret dette objektet mens du redigerte det — ingenting ble skrevet. Last inn på nytt og gjenta endringen på den ferske tilstanden.',
    staleReload: 'Last inn på nytt',
    preview: 'Forhåndsvisning',
    previewTitle: 'Forhåndsvisning av resultatet',
    previewNothingWritten: 'Simulert på serveren — ingenting ble skrevet.',
    previewChanged: 'Uthevet: verdiene som ville endret seg.'
  },
  context: {
    copySelection: 'Kopier markert tekst'
  },
  crud: {
    create: 'Opprett',
    viewDetails: 'Se detaljer',
    viewOrEdit: 'Se eller rediger',
    selected: 'valgt',
    viewUsingVms: 'Se VM-ene som bruker ressursen',
    clearSelection: 'Fjern utvalget',
    deleteSelected: 'Slett valgte',
    bulkConfirmBody: {
      one: 'Slette {count} valgt element? Hvis det er beskyttet, rapporteres det og beholdes.',
      other: 'Slette de {count} valgte elementene? De beskyttede rapporteres og beholdes.'
    },
    bulkDeleted: 'slettet',
    bulkRefused: 'avvist',
    fieldId: 'ID',
    createdAt: 'Opprettet',
    updatedAt: 'Oppdatert',
    immutableField: 'Fastsatt ved opprettelsen — contracten tillater ikke å endre det',
    immutableScope: 'Scopen tildeles ved opprettelsen; noen ressurser flyttes med en dedikert handling',
    observedField: 'Observert tilstand — rapportert av plattformen, ikke redigerbar'
  }
}
